// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const Examschedule = () => {
//   const [examData, setExamData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [addModalOpen, setAddModalOpen] = useState(false);
//   const [viewItem, setViewItem] = useState(null);
//   const [editItem, setEditItem] = useState(null);
//   const [sectionList, setSectionList] = useState([]);

//   const [formData, setFormData] = useState({
//     title: "",
//     from_date: "",
//     to_date: "",
//     section_id: "",
//     status: "",
//   });

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const examRes = await axios.get(
//           `${process.env.REACT_APP_API}/questions/examschedule`
//         );
//         setExamData(examRes.data);
//         const sectionRes = await axios.get(
//           `${process.env.REACT_APP_API}/questions/section`
//         );
//         setSectionList(sectionRes.data);
//       } catch (err) {
//         setError("Failed to load data");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, []);

//   const handleView = async (id) => {
//     const res = await axios.get(
//       `${process.env.REACT_APP_API}/questions/examschedule/${id}`
//     );
//     setViewItem(res.data);
//   };

//   const handleEdit = (item) => {
//     setFormData({
//       title: item.title,
//       from_date: item.from_date.split("T")[0],
//       to_date: item.to_date.split("T")[0],
//       section_id: item.section_id,
//       status: item.status,
//     });
//     setEditItem(item);
//   };

//   const handleUpdate = async () => {
//     try {
//       await axios.put(
//         `${process.env.REACT_APP_API}/questions/examschedule/${editItem.id}`,
//         formData
//       );
//       alert("Updated successfully");
//       setEditItem(null);
//       window.location.reload();
//     } catch (err) {
//       alert("Update failed");
//     }
//   };

//   const handleAdd = async () => {
//     try {
//       await axios.post(
//         `${process.env.REACT_APP_API}/questions/examschedule`,
//         formData
//       );
//       alert("Added successfully");
//       setAddModalOpen(false);
//       window.location.reload();
//     } catch (err) {
//       alert("Failed to add");
//     }
//   };

//   return (
//     <div>
//       <div
//         style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
//       >
//         <div
//           onClick={() => setAddModalOpen(true)}
//           style={{
//             width: "100px",
//             height: "70px",
//             backgroundColor: "blueviolet",
//             color: "white",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             cursor: "pointer",
//             margin: "10px",
//           }}
//         >
//           ADD +
//         </div>
//       </div>

//       <h2>Exam Schedule List</h2>

//       {loading ? (
//         <p>Loading...</p>
//       ) : error ? (
//         <p style={{ color: "red" }}>{error}</p>
//       ) : (
//         <table
//           border="1"
//           cellPadding="10"
//           style={{ width: "100%", borderCollapse: "collapse" }}
//         >
//           <thead>
//             <tr>
//               <th>S.No</th>
//               <th>Exam Title</th>
//               <th>From Date</th>
//               <th>To Date</th>
//               <th>Section</th>
//               <th>Status</th>
//               <th>Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {examData.length > 0 ? (
//               examData.map((item, index) => (
//                 <tr key={item.id}>
//                   <td>{index + 1}</td>
//                   <td>{item.title}</td>
//                   <td>{new Date(item.from_date).toLocaleDateString()}</td>
//                   <td>{new Date(item.to_date).toLocaleDateString()}</td>
//                   <td>
//                     {sectionList.find((sec) => sec.id === item.section_id)
//                       ?.section_name || item.section_id}
//                   </td>
//                   <td>{item.status}</td>
//                   <td>
//                     <button onClick={() => handleView(item.id)}>View</button>
//                     <button
//                       onClick={() => handleEdit(item)}
//                       style={{ marginLeft: "5px" }}
//                     >
//                       Edit
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="7" style={{ textAlign: "center" }}>
//                   No data available
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       )}

//       {/* View Modal */}
//       {viewItem && (
//         <div style={modalStyle}>
//           <div style={modalContentStyle}>
//             <h3>View Exam Details</h3>
//             <p>
//               <strong>Title:</strong> {viewItem.title}
//             </p>
//             <p>
//               <strong>From Date:</strong>{" "}
//               {new Date(viewItem.from_date).toLocaleDateString()}
//             </p>
//             <p>
//               <strong>To Date:</strong>{" "}
//               {new Date(viewItem.to_date).toLocaleDateString()}
//             </p>
//             <p>
//               <strong>Section ID:</strong> {viewItem.section_id}
//             </p>
//             <p>
//               <strong>Status:</strong> {viewItem.status}
//             </p>
//             <button onClick={() => setViewItem(null)}>Close</button>
//           </div>
//         </div>
//       )}

//       {/* Edit Modal */}
//       {editItem && (
//         <div style={modalStyle}>
//           <div style={modalContentStyle}>
//             <h3>Edit Exam Details</h3>
//             <input
//               type="text"
//               value={formData.title}
//               onChange={(e) =>
//                 setFormData({ ...formData, title: e.target.value })
//               }
//               placeholder="Title"
//             />
//             <input
//               type="date"
//               value={formData.from_date}
//               onChange={(e) =>
//                 setFormData({ ...formData, from_date: e.target.value })
//               }
//             />
//             <input
//               type="date"
//               value={formData.to_date}
//               onChange={(e) =>
//                 setFormData({ ...formData, to_date: e.target.value })
//               }
//             />
//             <select
//               value={formData.section_id}
//               onChange={(e) =>
//                 setFormData({ ...formData, section_id: e.target.value })
//               }
//             >
//               <option value="">Select Section</option>
//               {sectionList.map((sec) => (
//                 <option key={sec.id} value={sec.id}>
//                   {sec.section_name}
//                 </option>
//               ))}
//             </select>
//             <input
//               type="text"
//               value={formData.status}
//               onChange={(e) =>
//                 setFormData({ ...formData, status: e.target.value })
//               }
//               placeholder="Status"
//             />
//             <button onClick={handleUpdate}>Update</button>
//             <button
//               onClick={() => setEditItem(null)}
//               style={{ marginLeft: "10px" }}
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Add Modal */}
//       {addModalOpen && (
//         <div style={modalStyle}>
//           <div style={modalContentStyle}>
//             <h3>Add New Exam</h3>
//             <input
//               type="text"
//               value={formData.title}
//               onChange={(e) =>
//                 setFormData({ ...formData, title: e.target.value })
//               }
//               placeholder="Title"
//             />
//             <input
//               type="date"
//               value={formData.from_date}
//               onChange={(e) =>
//                 setFormData({ ...formData, from_date: e.target.value })
//               }
//             />
//             <input
//               type="date"
//               value={formData.to_date}
//               onChange={(e) =>
//                 setFormData({ ...formData, to_date: e.target.value })
//               }
//             />
//             <select
//               value={formData.section_id}
//               onChange={(e) =>
//                 setFormData({ ...formData, section_id: e.target.value })
//               }
//             >
//               <option value="">Select Section</option>
//               {sectionList.map((sec) => (
//                 <option key={sec.id} value={sec.id}>
//                   {sec.section_name}
//                 </option>
//               ))}
//             </select>
//             <input
//               type="text"
//               value={formData.status}
//               onChange={(e) =>
//                 setFormData({ ...formData, status: e.target.value })
//               }
//               placeholder="Status"
//             />
//             <button onClick={handleAdd}>Submit</button>
//             <button
//               onClick={() => setAddModalOpen(false)}
//               style={{ marginLeft: "10px" }}
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// const modalStyle = {
//   position: "fixed",
//   top: 0,
//   left: 0,
//   width: "100vw",
//   height: "100vh",
//   backgroundColor: "rgba(0,0,0,0.5)",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
//   zIndex: 1000,
// };

// const modalContentStyle = {
//   backgroundColor: "white",
//   padding: "20px",
//   borderRadius: "10px",
//   minWidth: "300px",
//   maxWidth: "500px",
//   display: "flex",
//   flexDirection: "column",
//   gap: "10px",
// };

// export default Examschedule;


import React, { useEffect, useState } from "react";
import axios from "axios";

const Examschedule = () => {
  const [examData, setExamData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [viewItem, setViewItem] = useState(null);
  const [editItem, setEditItem] = useState(null);
  const [sectionList, setSectionList] = useState([]);

  const [formData, setFormData] = useState({
    title: "",
    from_date: "",
    to_date: "",
    section_id: "",
    status: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const examRes = await axios.get(`${process.env.REACT_APP_API}/questions/examschedule`);
        setExamData(examRes.data);
        const sectionRes = await axios.get(`${process.env.REACT_APP_API}/questions/section`);
        setSectionList(sectionRes.data);
      } catch (err) {
        setError("Failed to load data");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleView = async (id) => {
    const res = await axios.get(`${process.env.REACT_APP_API}/questions/examschedule/${id}`);
    setViewItem(res.data);
  };

  const handleEdit = (item) => {
    setFormData({
      title: item.title,
      from_date: item.from_date.split("T")[0],
      to_date: item.to_date.split("T")[0],
      section_id: item.section_id,
      status: item.status,
    });
    setEditItem(item);
  };

  const handleUpdate = async () => {
    try {
      await axios.put(`${process.env.REACT_APP_API}/questions/examschedule/${editItem.id}`, formData);
      alert("Updated successfully");
      setEditItem(null);
      window.location.reload();
    } catch (err) {
      alert("Update failed");
    }
  };

  const handleAdd = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API}/questions/examschedule`, formData);
      alert("Added successfully");
      setAddModalOpen(false);
      window.location.reload();
    } catch (err) {
      alert("Failed to add");
    }
  };

  const inputStyle = {
    padding: "8px",
    width: "100%",
    border: "1px solid #ccc",
    borderRadius: "4px",
  };

  const modalStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  };

  const modalContentStyle = {
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "10px",
    minWidth: "300px",
    maxWidth: "500px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  };

  return (
    <div style={{ padding: "20px" }}>
      <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
        <div
          onClick={() => setAddModalOpen(true)}
          style={{
            width: "100px",
            height: "50px",
            backgroundColor: "blueviolet",
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            borderRadius: "5px",
          }}
        >
          ADD +
        </div>
      </div>

      <h2>Exam Schedule List</h2>

      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : (
        <table
          border="1"
          cellPadding="10"
          style={{ width: "100%", borderCollapse: "collapse", marginTop: "20px" }}
        >
          <thead>
            <tr>
              <th>S.No</th>
              <th>Exam Title</th>
              <th>From Date</th>
              <th>To Date</th>
              <th>Section</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {examData.length > 0 ? (
              examData.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.title}</td>
                  <td>{new Date(item.from_date).toLocaleDateString()}</td>
                  <td>{new Date(item.to_date).toLocaleDateString()}</td>
                  <td>{sectionList.find((sec) => sec.id === item.section_id)?.section_name || item.section_id}</td>
                  <td>{item.status}</td>
                  <td>
                    <button onClick={() => handleView(item.id)}>View</button>
                    <button onClick={() => handleEdit(item)} style={{ marginLeft: "5px" }}>
                      Edit
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" style={{ textAlign: "center" }}>
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}

      {/* View Modal */}
      {viewItem && (
        <div style={modalStyle}>
          <div style={modalContentStyle}>
            <h3>View Exam Details</h3>
            <p>
              <strong>Title:</strong> {viewItem.title}
            </p>
            <p>
              <strong>From Date:</strong> {new Date(viewItem.from_date).toLocaleDateString()}
            </p>
            <p>
              <strong>To Date:</strong> {new Date(viewItem.to_date).toLocaleDateString()}
            </p>
            <p>
              <strong>Section ID:</strong> {viewItem.section_id}
            </p>
            <p>
              <strong>Status:</strong> {viewItem.status}
            </p>
            <button onClick={() => setViewItem(null)}>Close</button>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {editItem && (
        <div style={modalStyle}>
          <div style={modalContentStyle}>
            <h3>Edit Exam</h3>
            <input
              type="text"
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              placeholder="Title"
              style={inputStyle}
            />
            <input
              type="date"
              value={formData.from_date}
              onChange={(e) => setFormData({ ...formData, from_date: e.target.value })}
              style={inputStyle}
            />
            <input
              type="date"
              value={formData.to_date}
              onChange={(e) => setFormData({ ...formData, to_date: e.target.value })}
              style={inputStyle}
            />
            <select
              value={formData.section_id}
              onChange={(e) => setFormData({ ...formData, section_id: e.target.value })}
              style={inputStyle}
            >
              <option value="">Select Section</option>
              {sectionList.map((sec) => (
                <option key={sec.id} value={sec.id}>
                  {sec.section_name}
                </option>
              ))}
            </select>
          <select
  value={formData.status}
  onChange={(e) => setFormData({ ...formData, status: e.target.value })}
  style={inputStyle}
>
  <option value="">Select Status</option>
  <option value="Active">Active</option>
  <option value="Inactive">Inactive</option>
</select>

            <button onClick={handleUpdate} style={{ ...inputStyle, backgroundColor: "green", color: "white" }}>
              Update
            </button>
            <button onClick={() => setEditItem(null)} style={{ ...inputStyle, marginTop: "5px" }}>
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* Add Modal */}
      {addModalOpen && (
        <div style={modalStyle}>
          <div style={modalContentStyle}>
            <h3>Add New Exam</h3>
            <input
              type="text"
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              placeholder="Title"
              style={inputStyle}
            />
            <input
              type="date"
              value={formData.from_date}
              onChange={(e) => setFormData({ ...formData, from_date: e.target.value })}
              style={inputStyle}
            />
            <input
              type="date"
              value={formData.to_date}
              onChange={(e) => setFormData({ ...formData, to_date: e.target.value })}
              style={inputStyle}
            />
            <select
              value={formData.section_id}
              onChange={(e) => setFormData({ ...formData, section_id: e.target.value })}
              style={inputStyle}
            >
              <option value="">Select Section</option>
              {sectionList.map((sec) => (
                <option key={sec.id} value={sec.id}>
                  {sec.section_name}
                </option>
              ))}
            </select>
            {/* <input
              type="text"
              value={formData.status}
              onChange={(e) => setFormData({ ...formData, status: e.target.value })}
              placeholder="Status"
              style={inputStyle}
            /> */}
            <button onClick={handleAdd} style={{ ...inputStyle, backgroundColor: "blue", color: "white" }}>
              Submit
            </button>
            <button
              onClick={() => setAddModalOpen(false)}
              style={{ ...inputStyle, marginTop: "5px" }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Examschedule;
